module.exports = __webpack_public_path__ + "../resources/img/tooltip_icon.a127763d.svg";